import React from "react";
import {
  DurationAggretorWrapper,
  DurationSelector,
  ButtonText,
} from "./styles";

const duration = [
  {
    text: "Week",
    value: "week",
  },
  {
    text: "Day",
    value: "day",
  },
  {
    text: "Hour",
    value: "hour",
  },
];

const DurationAggregator = ({ onChange, selection, disabled }) => (
  <DurationAggretorWrapper onChange={onChange} value={selection}>
    {duration.map((item, index) => (
      <DurationSelector
        color="clientPrimary"
        borderColor="clientPrimary"
        value={item.value}
        key={`${item.text}${index}`}
        px={2}
        py={1}
        disabled={disabled}
      >
        <ButtonText fontSize={3} fontWeight="600">
          {item.text}
        </ButtonText>
      </DurationSelector>
    ))}
  </DurationAggretorWrapper>
);

export default DurationAggregator;
